import { LeadCurd } from "./leadCrud";

export default function PoolLeads() {
  return <LeadCurd name="废物池" type="waste" router="waste" />;
}
